<template>
  <nuxt-link
    class="c-popularCategory"
    :to="linkPath"
  >
    <img
      class="c-popularCategory_icon"
      :src="iconSrc"
      :alt="fixedIconAlt"
      loading="lazy"
      decoding="async"
    >
    <div
      class="c-popularCategory_text"
      v-html="text"
    >
    </div>
  </nuxt-link>
</template>

<script>
export default {
  name: 'PopularCategory',
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    iconSrc: {
      type: String,
      required: true
    },
    iconAlt: {
      type: String,
      default: null
    }
  },
  computed: {
    fixedIconAlt() {
      return this.iconAlt || this.text
    },
    linkPath() {
      return `/categories/${this.categoryId}`
    }
  }
}
</script>

<style lang="scss" scoped>
$breakpoint-xs: 376px;

.c-popularCategory {
  @include link-effect;

  display: flex;
  flex-direction: column;

  align-items: center;
  &_icon {
    display: block;
    width: 60px;
    height: 60px;
  }
  &_text {
    margin-top: 8px;
    color: $color-gray-900;
    text-align: center;
  }
}

@media (max-width: breakpoint(Home, M)) {
  .c-popularCategory {
    &_text {
      margin-top: 10px;
      font-size: 12px;
    }
  }
}

@media (max-width: $breakpoint-xs) {
  .c-popularCategory {
    &_text {
      font-size: calc(100vw * 12 / 375);
    }
  }
}
</style>
